import { render } from "./ModalEditarTarefaProtocolo.vue?vue&type=template&id=db0a8304"
import script from "./ModalEditarTarefaProtocolo.vue?vue&type=script&lang=js"
export * from "./ModalEditarTarefaProtocolo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__